import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

try {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
} catch (err) {
  // If React fails to mount, show a basic fallback so the page isn't blank
  var root = document.getElementById("root");
  if (root) {
    root.innerHTML =
      '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;flex-direction:column;font-family:system-ui,sans-serif;padding:20px;text-align:center">' +
      '<h2 style="color:#16a34a;margin-bottom:12px">Enko Home Buyers</h2>' +
      '<p style="color:#555;margin-bottom:20px">Page is loading. If this persists, please call us directly.</p>' +
      '<a href="mailto:alex@enkohomebuyers.com" style="background:#16a34a;color:#fff;padding:14px 32px;border-radius:8px;text-decoration:none;font-size:18px;font-weight:bold">Email alex@enkohomebuyers.com</a>' +
      '<button onclick="window.location.reload()" style="margin-top:16px;background:none;border:1px solid #ccc;padding:10px 24px;border-radius:6px;cursor:pointer;color:#333">Refresh Page</button>' +
      '</div>';
  }
  console.error("React mount failed:", err);
}
